export const useKeys = (userKeys) => {
    return (e) => {
        const handler = userKeys[e.code];
        if (typeof handler === "function") {
            handler(e);
        }
    };
};
